import { FlagsContextModel } from 'config/useFlagsContext'
import { EncaminhamentoEspecializadoByIdQuery } from 'graphql/types.generated'
import { LotacaoContextModel } from 'hooks/atendimento-context/model-atendimentoContext'
import { LotacaoAtendimento } from 'view/atendimentos/types/AtendimentoProfissionalModel'

import { canRegisterCid10 } from '../../../cuidado-compartilhado/cuidado-compartilhado-form/utils-cuidadoCompartilhado'
import { classificacaoRiscoRecord, EncaminhamentoExternoEspecializadoModel } from '../../model-encaminhamentoExterno'
import { EncaminhamentoExternoDetalhesPanelModel } from '../model'

function getHipoteseDiagnostica(
  shouldRenderCid: boolean,
  cid?: { nome?: string | null; codigo?: string | null },
  ciap?: { descricao?: string | null; codigo?: string | null }
): string | undefined {
  if (shouldRenderCid) {
    return cid?.nome && cid?.codigo ? `${cid.nome} - ${cid.codigo}` : cid?.nome ?? cid?.codigo ?? undefined
  }

  return ciap?.descricao && ciap?.codigo
    ? `${ciap.descricao} - ${ciap.codigo}`
    : ciap?.descricao ?? ciap?.codigo ?? undefined
}

export function convertEncaminhamentoEspecializadoRecente(
  encaminhamento: EncaminhamentoExternoEspecializadoModel,
  lotacao: LotacaoAtendimento | LotacaoContextModel,
  flags: FlagsContextModel
): EncaminhamentoExternoDetalhesPanelModel | undefined {
  if (!encaminhamento) return undefined

  const canAcessoCBORegisterCid10 = canRegisterCid10(lotacao.cbo?.cbo2002, !encaminhamento.cidEncaminhamento, flags)

  return {
    especialidade: encaminhamento.especialidadeSisreg?.descricao,
    complemento: encaminhamento.complemento,
    renderCiap: !canAcessoCBORegisterCid10,
    hipoteseDiagnostica: getHipoteseDiagnostica(
      canAcessoCBORegisterCid10,
      encaminhamento.cidEncaminhamento,
      encaminhamento.ciapEncaminhamento
    ),
    classificacaoRisco: classificacaoRiscoRecord[encaminhamento.classificacaoRiscoEncaminhamento]?.label,
    motivo: encaminhamento.motivoEncaminhamento,
    observacoes: encaminhamento.observacoes,
    lotacao: {
      nome: lotacao.profissional?.nome,
      cbo: lotacao.cbo?.nome,
      cns: lotacao.profissional?.cns,
      cpf: lotacao.profissional?.cpf,
    },
  }
}

export function convertEncaminhamentoEspecializado(
  encaminhamento: EncaminhamentoEspecializadoByIdQuery['encaminhamentoEspecializado'],
  flags: FlagsContextModel
): EncaminhamentoExternoDetalhesPanelModel | undefined {
  if (!encaminhamento) return undefined

  const canAcessoCBORegisterCid10 = canRegisterCid10(
    encaminhamento.atendimentoProfissional.lotacao.cbo?.cbo2002,
    !encaminhamento.hipoteseDiagnosticoCid10,
    flags
  )

  return {
    especialidade: encaminhamento.especialidadeSisreg?.descricao,
    complemento: encaminhamento.complemento,
    renderCiap: !canAcessoCBORegisterCid10,
    hipoteseDiagnostica: getHipoteseDiagnostica(
      canAcessoCBORegisterCid10,
      encaminhamento.hipoteseDiagnosticoCid10,
      encaminhamento.hipoteseDiagnosticoCiap
    ),
    classificacaoRisco: classificacaoRiscoRecord[encaminhamento.classificacaoRiscoEncaminhamento]?.label,
    motivo: encaminhamento.motivoEncaminhamento,
    observacoes: encaminhamento.observacoes,
    lotacao: {
      nome: encaminhamento.atendimentoProfissional.lotacao.profissional?.nome,
      cpf: encaminhamento.atendimentoProfissional.lotacao.profissional?.cpf,
      cns: encaminhamento.atendimentoProfissional.lotacao.profissional?.cns,
      cbo: encaminhamento.atendimentoProfissional.lotacao.cbo?.nome,
    },
  }
}
